<template>
    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">办公系统</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/workflow/flowArticle' }">发文管理</el-breadcrumb-item>
        <el-breadcrumb-item>编辑推文</el-breadcrumb-item>
    </el-breadcrumb>

    <div class="article-pusher">
        <el-form :model="formData" label-width="120px">
            <el-form-item label="标题">
                <el-select v-model="formData.articleType" placeholder="请选择发文栏目"
                    style="width: 180px; margin-right: 10px;">
                    <el-option label="推荐" value="推荐">
                        <span style="float: left">推荐</span>
                        <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">
                            推荐文章
                        </span>
                    </el-option>
                    <el-option label="热门" value="热门">
                        <span style="float: left">热门</span>
                        <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">
                            热门文章
                        </span>
                    </el-option>
                    <el-option label="公告" value="公告">
                        <span style="float: left">公告</span>
                        <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">
                            公司通告
                        </span>
                    </el-option>
                    <el-option label="通知" value="通知">
                        <span style="float: left">通知</span>
                        <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">
                            公共通知
                        </span>
                    </el-option>
                    <el-option label="月刊" value="月刊">
                        <span style="float: left">月刊</span>
                        <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">
                            内部月刊
                        </span>
                    </el-option>
                    <el-option label="指引" value="指引">
                        <span style="float: left">指引</span>
                        <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">
                            系统操作指引
                        </span>
                    </el-option>
                </el-select>
                <el-input v-model="formData.title" placeholder="请输入文章标题" style="max-width: 60%;" />
            </el-form-item>

            <el-form-item label="副标题">
                <el-input v-model="formData.subTitle" placeholder="请输入副标题" style="max-width: 60%;" />
            </el-form-item>

            <el-form-item label="公告推送">
                <el-switch v-model="formData.noticePushEnabled" active-text="启用" inactive-text="关闭" />
                <span style="margin-left: 10px; color: var(--el-text-color-secondary); font-size: 13px;">
                    审核通过后自动触发公告推送
                </span>
            </el-form-item>

            <el-form-item label="有效期至">
                <el-date-picker v-model="formData.expiryDate" type="datetime" clearable
                    format="YYYY-MM-DD HH:mm:ss" value-format="YYYY-MM-DD HH:mm:ss"
                    placeholder="不填写表示长期有效" style="width: 240px;" />
                <span style="margin-left: 10px; color: var(--el-text-color-secondary); font-size: 13px;">
                    不填写表示长期有效；到期后不再出现在公开文章列表和顶部轮播。
                </span>
            </el-form-item>

            <el-form-item label="部门及发布人">
                <el-input v-model="formData.publishDeptName" placeholder="部门名称"
                    style="max-width: 130px; margin-right: 12px;" />
                <el-input v-model="formData.publishUserName" placeholder="发布人姓名" style="max-width: 220px;" />
            </el-form-item>

            <el-form-item label="附件上传">
                <div style="width: 100%;">
                    <el-upload :action="uploadAction" list-type="picture-card" :on-success="uploadHandleSuccess"
                        :on-preview="previewHandle" :before-upload="uploadHandleBefore" :file-list="fileList"
                        accept="*/*">
                        <el-icon>
                            <Plus />
                        </el-icon>
                        <template #file="{ file }">
                            <div>
                                <img v-if="file.ext === 'jpg' || file.ext === 'jpeg' || file.ext === 'png' || file.ext === 'bmp'"
                                    class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                                <div v-else
                                    style="font-size: 1em; width: 100%; text-align: center; font-weight: 800; display: flex; align-items: center; padding: 10px;">
                                    <span style="overflow-wrap: anywhere;">{{ file.name }}</span>
                                </div>
                                <span class="el-upload-list__item-actions">
                                    <span class="el-upload-list__item-preview" @click="previewHandle(file)" title="预览">
                                        <el-icon>
                                            <ZoomIn />
                                        </el-icon>
                                    </span>
                                    <span class="el-upload-list__item-delete" @click="downloadHandle(file)" title="下载">
                                        <el-icon>
                                            <Download />
                                        </el-icon>
                                    </span>
                                    <span class="el-upload-list__item-delete" @click="removeHandle(file)" title="删除">
                                        <el-icon>
                                            <Delete />
                                        </el-icon>
                                    </span>
                                </span>
                            </div>
                        </template>
                    </el-upload>
                </div>
            </el-form-item>


            <el-form-item label="正文内容">
                <div class="article-editor-shell" @paste.capture="handleEditorPaste" @drop.capture="handleEditorDrop"
                    @dragover.prevent>
                    <div class="article-image-toolbar">
                        <el-button size="small" type="primary" plain :loading="imageUploading"
                            :disabled="!articleDataId" @click="openDirectImagePicker">
                            上传图片
                        </el-button>
                        <el-button size="small" :disabled="!articleDataId" @click="openImageManager(false)">
                            图片资源
                        </el-button>
                        <span class="article-image-tip">支持粘贴或拖拽 JPG、PNG、WebP、GIF，单图不超过10MB</span>
                        <input ref="articleImageInput" class="article-image-input" type="file" multiple
                            accept="image/jpeg,image/png,image/webp,image/gif" @change="handleDirectImageFiles">
                    </div>
                    <el-progress v-if="imageUploading" :percentage="imageUploadProgress" :stroke-width="6" />
                    <Toolbar style="border-bottom: 1px solid #ccc" :editor="editorRef" :defaultConfig="toolbarConfig"
                        :mode="mode" />
                    <div v-if="hasSelectedImage" class="article-image-format-bar">
                        <span class="format-label">图片排版</span>
                        <el-button-group>
                            <el-button v-for="width in [25, 50, 75, 100]" :key="width" size="small"
                                :type="selectedImageForm.width === width ? 'primary' : 'default'"
                                @click="setSelectedImageWidth(width)">{{ width }}%</el-button>
                        </el-button-group>
                        <el-slider v-model="selectedImageForm.width" :min="10" :max="100" :step="1"
                            style="width: 150px; margin: 0 12px;" @change="setSelectedImageWidth" />
                        <el-radio-group v-model="selectedImageForm.align" size="small" @change="setSelectedImageAlign">
                            <el-radio-button label="left">左对齐</el-radio-button>
                            <el-radio-button label="center">居中</el-radio-button>
                            <el-radio-button label="right">右对齐</el-radio-button>
                        </el-radio-group>
                        <el-input v-model="selectedImageForm.alt" size="small" placeholder="替代文本"
                            style="width: 150px;" @change="updateSelectedImageText" />
                        <el-input v-model="selectedImageForm.caption" size="small" placeholder="图片说明（可选）"
                            style="width: 180px;" @change="updateSelectedImageText" />
                        <el-button size="small" @click="replaceSelectedImage">替换</el-button>
                        <el-button size="small" type="danger" plain @click="removeSelectedImage">从正文移除</el-button>
                    </div>
                    <Editor style="height: 400px; overflow-y: hidden;" v-model="formData.content"
                        :defaultConfig="editorConfig" :mode="mode" @onCreated="handleCreated"
                        @onChange="handleEditorChange" />
                </div>
            </el-form-item>

            <el-form-item>
                <el-button type="primary" @click="handleSubmit()">保存</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="$router.back()">返回</el-button>
            </el-form-item>
        </el-form>
    </div>

    <ArticleImageManager ref="imageManager" v-model:visible="imageManagerVisible" :article-id="articleDataId"
        :reference-counts="imageReferenceCounts" :replace-mode="replaceImageMode"
        @choose="handleImageResourceChoose" @locate="locateArticleImage" @changed="refreshImageReferences" />
</template>

<script>
import { shallowRef } from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import '@wangeditor/editor/dist/css/style.css'
import { Plus, ZoomIn, Download, Delete } from '@element-plus/icons-vue'
import util from '@/utils/util'
import kaung from '@/utils/kaung.js'
import { fetchFileList, delFile } from '@/api/basic'
import { uploadArticleImage } from '@/api/flow-article-image'
import ArticleImageManager from './ArticleImageManager.vue'
import {
    focusArticleImage,
    getArticleImageReferenceCounts,
    getSelectedArticleImage,
    insertArticleImage,
    removeSelectedArticleImage,
    selectArticleImage,
    updateSelectedArticleImage
} from './article-image-module'

export default {
    name: "FlowArticlePusher",
    components: {
        Editor,
        Toolbar,
        Plus,
        ZoomIn,
        Download,
        Delete,
        ArticleImageManager
    },
    data() {
        return {
            editorRef: shallowRef(),
            mode: 'default',
            id: null,
            formData: {
                title: '',
                subTitle: '',
                noticePushEnabled: false,
                expiryDate: null,
                publishDeptName: '',
                publishUserName: '',
                content: '',
                uniqueCode: '',
                id: ''
            },
            fileList: [],
            // 正文图片资源抽屉是否显示。
            imageManagerVisible: false,
            // true 表示从资源抽屉选择图片后替换当前图块，否则在光标处插入。
            replaceImageMode: false,
            // 编辑器直接上传（选择、粘贴、拖拽）的状态与总进度。
            imageUploading: false,
            imageUploadProgress: 0,
            // 当前未保存编辑内容中，各图片资源 ID 对应的引用次数。
            imageReferenceCounts: {},
            // 当前 Slate 选区是否位于文章图片图块。
            hasSelectedImage: false,
            // 与图片排版工具栏绑定的当前图块属性副本。
            selectedImageForm: {
                resourceId: '',
                width: 100,
                align: 'center',
                alt: '',
                caption: ''
            },
            toolbarConfig: {
                // 禁用 wangEditor 自带图片入口，统一经过文章图片专用上传与资源校验。
                excludeKeys: [
                    'group-image',
                    'group-video',
                    'uploadImage',
                    'insertImage',
                    'uploadVideo',
                    'insertVideo'
                ]
            },
            editorConfig: {
                placeholder: '请输入文章正文内容...',
                MENU_CONF: {},
                // 添加错误处理配置
                onError: (err) => {
                    console.warn('Editor error:', err)
                }
            }
        }
    },
    computed: {
        apiUrl() {
            return process.env.VUE_APP_BASEURL
        },
        uploadAction() {
            return `${this.apiUrl}BaseUploader/Basic?dataType=FlowArticle&dataID=${this.formData.uniqueCode || this.formData.id || ''}&fileType=form&fileCode=${this.formData.uniqueCode || this.formData.id || ''}`
        },
        articleDataId() {
            // 新建页优先使用 getid() 的预留 ID，编辑页使用已有文章 ID。
            return this.formData.uniqueCode || this.formData.id || this.id || ''
        }
    },
    mounted() {
        this.$kaung = kaung.init('FlowArticle');
        this.handleReset();
        this.handleLoad();
    },
    beforeUnmount() {
        const editor = this.editorRef
        if (editor == null) return
        try {
            editor.destroy()
        } catch (e) {
            console.warn('Editor destroy error:', e)
        }
    },
    methods: {
        /** 打开正文图片的原生文件选择器。 */
        openDirectImagePicker() {
            this.$refs.articleImageInput?.click()
        },
        /** 初始化编辑器并注册文章图片选择、缩放和属性更新事件。 */
        handleCreated(editor) {
            this.editorRef = editor
            editor.on('article-image-select', node => {
                selectArticleImage(editor, node)
                this.refreshSelectedImage()
            })
            editor.on('article-image-resize', () => {
                this.refreshSelectedImage()
                this.refreshImageReferences()
            })
            editor.on('article-image-updated', () => {
                this.refreshSelectedImage()
                this.refreshImageReferences()
            })
            // 编辑器创建后，设置初始内容（避免空内容导致的错误）
            if (!this.formData.content) {
                editor.dangerouslyInsertHtml('<p><br></p>')
            }
            this.refreshImageReferences()
        },
        /** 正文变化后同步当前选中图块和资源引用次数。 */
        handleEditorChange() {
            this.refreshSelectedImage()
            this.refreshImageReferences()
        },
        handleReset() {
            this.formData = {
                title: '',
                subTitle: '',
                noticePushEnabled: false,
                expiryDate: null,
                publishDeptName: '',
                publishUserName: '',
                content: '',
                uniqueCode: '', //util.getUUID(16, 36),
                id: ''
            }
            this.fileList = []
            this.imageReferenceCounts = {}
            this.hasSelectedImage = false
            this.imageManagerVisible = false
            this.replaceImageMode = false

            // 重置编辑器内容
            if (this.editorRef) {
                try {
                    this.editorRef.clear()
                    // 设置一个空段落，避免完全为空导致错误
                    this.editorRef.dangerouslyInsertHtml('<p><br></p>')
                } catch (e) {
                    console.warn('Editor reset error:', e)
                }
            }

            console.log(this.formData)
        },
        /** 将接口返回的日期时间转换为日期选择器使用的本地字符串格式。 */
        normalizeExpiryDate(value) {
            if (!value) return null
            return String(value).replace('T', ' ').slice(0, 19)
        },
        handleSubmit() {
            // 主动读取编辑器序列化结果，确保最后一次图片属性修改被提交。
            if (this.editorRef) {
                this.formData.content = this.editorRef.getHtml()
            }
            if (!this.formData.title) {
                this.$kaung.message('请输入标题')
                return
            }
            if (!this.formData.content || (this.editorRef && this.editorRef.isEmpty())) {
                this.$kaung.message('请输入正文内容')
                return
            }

            // 同步附件路径数组到 attachments 字段
            if (this.fileList && this.fileList.length > 0) {
                this.formData.attachments = this.fileList.map(file => file.url || file.response?.data?.url || '').filter(url => url).join(';')
            } else {
                this.formData.attachments = ''
            }

            kaung.post({
                url: '/FlowArticle/' + (this.id || ''),
                method: this.id ? 'put' : 'post',
                data: this.formData
            }).then((res) => {
                if (res.code === 200) {
                    this.formData = { ...this.formData, ...res.data };
                    kaung.success(res.content || '操作成功');
                    this.$router.back();
                } else {
                    kaung.error(res.content || '操作失败')
                }
            }).catch((error) => {
                kaung.error(error.message || '操作失败')
            })
        },
        /** 打开图片资源抽屉，并指定本次操作是插入还是替换。 */
        openImageManager(replaceMode = false) {
            if (!this.articleDataId) {
                this.$message.warning('文章编号尚未准备完成，请稍后再试')
                return
            }
            this.replaceImageMode = replaceMode
            this.imageManagerVisible = true
        },
        /** 处理“上传图片”文件选择结果。 */
        handleDirectImageFiles(event) {
            const files = Array.from(event.target.files || [])
            event.target.value = ''
            this.uploadAndInsertImages(files)
        },
        /**
         * 截获编辑器粘贴图片文件并上传；包含 img 的 HTML 粘贴会被明确阻止。
         */
        handleEditorPaste(event) {
            const clipboard = event.clipboardData
            if (!clipboard) return
            const files = Array.from(clipboard.files || []).filter(file => file.type && file.type.startsWith('image/'))
            if (files.length > 0) {
                event.preventDefault()
                event.stopPropagation()
                this.uploadAndInsertImages(files)
                return
            }
            const html = clipboard.getData('text/html') || ''
            if (/<img\b/i.test(html)) {
                event.preventDefault()
                event.stopPropagation()
                this.$message.warning('不允许直接粘贴外链或base64图片，请粘贴图片文件或使用上传功能')
            }
        },
        /** 截获拖入编辑器的图片文件，避免 wangEditor 生成 base64 节点。 */
        handleEditorDrop(event) {
            const files = Array.from(event.dataTransfer?.files || []).filter(file => file.type && file.type.startsWith('image/'))
            if (!files.length) return
            event.preventDefault()
            event.stopPropagation()
            this.uploadAndInsertImages(files)
        },
        /** 执行正文图片前端类型和大小校验。 */
        validateArticleImageFile(file) {
            const allowedTypes = ['image/jpeg', 'image/png', 'image/webp', 'image/gif']
            if (!allowedTypes.includes(file.type)) return '仅支持JPG、PNG、WebP和GIF图片'
            if (!file.size) return '图片文件不能为空'
            if (file.size > 10 * 1024 * 1024) return '单张图片不能超过10MB'
            return ''
        },
        /**
         * 所有直接上传入口共用的方法：顺序上传，并仅在成功后插入图块。
         */
        async uploadAndInsertImages(files) {
            if (!files || files.length === 0) return
            if (this.imageUploading) {
                this.$message.info('已有图片正在上传，请稍候')
                return
            }
            if (!this.articleDataId) {
                this.$message.warning('文章编号尚未准备完成，请稍后再试')
                return
            }
            if (!this.editorRef) return

            this.imageUploading = true
            this.imageUploadProgress = 0
            let completed = 0
            for (const file of files) {
                const validationError = this.validateArticleImageFile(file)
                if (validationError) {
                    this.$message.warning(`${file.name}：${validationError}`)
                    completed++
                    continue
                }
                try {
                    const response = await uploadArticleImage(this.articleDataId, file, progress => {
                        this.imageUploadProgress = Math.round(((completed + progress / 100) / files.length) * 100)
                    })
                    if (response.code === 200) {
                        insertArticleImage(this.editorRef, response.data)
                    } else {
                        this.$message.error(response.content || `${file.name} 上传失败`)
                    }
                } catch (error) {
                    this.$message.error(error.content || `${file.name} 上传失败`)
                }
                completed++
                this.imageUploadProgress = Math.round((completed / files.length) * 100)
            }
            this.imageUploading = false
            this.refreshImageReferences()
            if (this.$refs.imageManager) this.$refs.imageManager.refresh()
        },
        /** 处理资源抽屉选择结果，按当前模式插入或替换图块。 */
        handleImageResourceChoose(resource) {
            if (!this.editorRef || !resource) return
            if (this.replaceImageMode && this.hasSelectedImage) {
                updateSelectedArticleImage(this.editorRef, {
                    resourceId: resource.id,
                    src: resource.url || resource.path,
                    alt: resource.name || '图片'
                })
            } else {
                insertArticleImage(this.editorRef, resource)
            }
            this.replaceImageMode = false
            this.refreshSelectedImage()
            this.refreshImageReferences()
        },
        /** 从 Slate 当前选区刷新排版工具栏表单。 */
        refreshSelectedImage() {
            const node = getSelectedArticleImage(this.editorRef)
            this.hasSelectedImage = !!node
            if (!node) return
            this.selectedImageForm = {
                resourceId: node.resourceId || '',
                width: Number(node.width || 100),
                align: node.align || 'center',
                alt: node.alt || '',
                caption: node.caption || ''
            }
        },
        /** 重新统计当前编辑内容中的图片资源引用次数。 */
        refreshImageReferences() {
            this.imageReferenceCounts = getArticleImageReferenceCounts(this.editorRef)
        },
        /** 应用快捷按钮或滑块选择的相对宽度。 */
        setSelectedImageWidth(width) {
            width = Math.min(100, Math.max(10, Number(width || 100)))
            this.selectedImageForm.width = width
            updateSelectedArticleImage(this.editorRef, { width })
        },
        /** 应用当前图片的左、中、右对齐方式。 */
        setSelectedImageAlign(align) {
            updateSelectedArticleImage(this.editorRef, { align })
        },
        /** 将替代文本和可选说明写回当前图片节点。 */
        updateSelectedImageText() {
            updateSelectedArticleImage(this.editorRef, {
                alt: this.selectedImageForm.alt || '图片',
                caption: this.selectedImageForm.caption || ''
            })
        },
        /** 打开资源抽屉，为当前图片选择新的资源。 */
        replaceSelectedImage() {
            if (!this.hasSelectedImage) return
            this.openImageManager(true)
        },
        /** 仅删除正文节点，保留资源并交由编辑器历史记录支持撤销。 */
        removeSelectedImage() {
            if (!this.hasSelectedImage) return
            this.$confirm('仅从正文移除该图片，图片资源仍会保留。是否继续？', '移除正文图片', {
                type: 'warning',
                confirmButtonText: '移除',
                cancelButtonText: '取消'
            }).then(() => {
                removeSelectedArticleImage(this.editorRef)
                this.hasSelectedImage = false
                this.refreshImageReferences()
            }).catch(() => { })
        },
        /** 关闭资源抽屉并定位正文中第一个引用该资源的图块。 */
        locateArticleImage(resourceId) {
            this.imageManagerVisible = false
            if (!focusArticleImage(this.editorRef, resourceId)) {
                this.$message.info('当前未保存正文中没有找到该图片，请先保存文章再删除资源')
                return
            }
            this.refreshSelectedImage()
        },
        // 获取附件列表
        getFileList() {
            const dataID = this.formData.uniqueCode || this.formData.id
            console.log('dataID', dataID)
            if (!dataID) return

            fetchFileList(dataID).then((res) => {
                if (res.code === 200) {
                    this.fileList = res.data || []
                }
            })
        },
        // 上传前检查
        uploadHandleBefore(file) {
            if (!this.formData.uniqueCode && !this.formData.id) {
                this.$message.warning('请先保存文章后再上传附件')
                return false
            }
            return true
        },
        // 上传成功
        uploadHandleSuccess(res, file, uploadFileList) {
            if (res.code === 200) {
                this.$message.success(res.content || '上传成功')
                this.getFileList()
            } else {
                this.$message.error(res.content || '上传失败')
            }
        },
        // 预览文件
        previewHandle(file) {
            window.open('/preview?id=' + file.id)
        },
        // 下载文件
        downloadHandle(file) {
            window.open(file.url)
        },
        // 删除文件
        removeHandle(file) {
            const userInfo = this.$store.state.userInfo
            const role = userInfo.roles?.filter(x => x.toLowerCase() === 'admin') || []

            this.$confirm('确定要删除该附件吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delFile(file.id).then((res) => {
                    if (res.code === 200) {
                        this.$message.success(res.content || '删除成功')
                        this.getFileList()
                    } else {
                        this.$message.error(res.content || '删除失败')
                    }
                })
            }).catch(() => { })
        },
        handleLoad() {
            this.id = this.$route.query.id;
            if (!this.id) {
                this.$kaung.getid().then((res) => {
                    if (res.code === 200) {
                        this.formData.id = res.data;
                        this.formData.uniqueCode = res.data;
                        // 获取到 uniqueCode 后立即加载附件列表
                        this.getFileList();
                    } else {
                        kaung.error(res.content || '获取ID失败')
                    }
                }).catch((error) => {
                    kaung.error(error.message || '获取ID失败')
                });

                return;
            }

            console.log(this.id)

            kaung.fetch({
                url: '/FlowArticle/' + this.id,
                method: 'get'
            }).then((res) => {
                this.formData = { ...this.formData, ...res.data };
                this.formData.expiryDate = this.normalizeExpiryDate(res.data?.expiryDate)
                console.log('formData', this.formData)
                this.getFileList();
            }).catch((error) => {
                kaung.error(error.message)
            })
        }
    }
}
</script>

<style scoped>
.article-pusher {
    padding: 20px;
}

.article-editor-shell {
    width: 100%;
    border: 1px solid #ccc;
}

.article-image-toolbar,
.article-image-format-bar {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    padding: 8px 10px;
    border-bottom: 1px solid var(--el-border-color);
    background: var(--el-fill-color-lighter);
}

.article-image-format-bar {
    background: var(--el-color-primary-light-9);
}

.article-image-input {
    display: none;
}

.article-image-tip {
    color: var(--el-text-color-secondary);
    font-size: 12px;
}

.format-label {
    font-size: 13px;
    font-weight: 600;
}

.article-editor-shell :deep(.article-image-block) {
    box-sizing: border-box;
    margin-top: 12px;
    margin-bottom: 12px;
    padding: 4px;
    border: 2px solid transparent;
    border-radius: 4px;
}

.article-editor-shell :deep(.article-image-block[data-selected="true"]) {
    border-color: var(--el-color-primary);
}

.article-editor-shell :deep(.article-image-preview) {
    display: block;
    width: 100%;
    max-width: 100%;
    height: auto;
}

.article-editor-shell :deep(.article-image-caption) {
    padding: 6px 4px 2px;
    color: var(--el-text-color-secondary);
    text-align: center;
    font-size: 13px;
}

.article-editor-shell :deep(.article-image-resize-handle) {
    position: absolute;
    right: -6px;
    bottom: -6px;
    display: none;
    width: 12px;
    height: 12px;
    border: 2px solid #fff;
    border-radius: 50%;
    background: var(--el-color-primary);
    cursor: nwse-resize;
}

.article-editor-shell :deep(.article-image-block[data-selected="true"] .article-image-resize-handle) {
    display: block;
}

.article-pusher :deep(.el-upload-list--picture-card .el-upload-list__item) {
    width: 90px;
    height: 90px;
}

.article-pusher :deep(.el-upload--picture-card) {
    width: 90px;
    height: 90px;
    line-height: 90px;
}

.article-pusher :deep(.el-upload-list--picture-card .el-upload-list__item-thumbnail) {
    width: 100%;
    height: 100%;
}

.article-pusher :deep(.el-upload-list__item-actions span + span) {
    margin-left: 3px;
}

@media (max-width: 900px) {
    .article-image-format-bar :deep(.el-input) {
        width: 100% !important;
    }
}
</style>
